import { Container, Col, Row, Table, Badge } from "reactstrap";
import { Link } from "react-router-dom";
import * as Notify from "@repoflow/form-schema/notify";
import * as Section from "@repoflow/components/section";
import { Mutation, Button } from "@repoflow/components/section";
import * as QueriesQL from "queries/site-domain";
import { ACTIVE } from "@common/schema/site-domain/status";
import { TXT_PREFIX } from "@common/schema/site-domain/txt";
import { Setup } from "../setup";

export const Sidebar = () => null;

export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base } = Section.useSectionContext();

  return (
    <Container>
      <div className="mt-4" />

      <Row>
        <Col>
          <Setup />
        </Col>
      </Row>

      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Attach
          </Link>
        </Col>
      </Row>

      <div className="mt-4" />

      <Section.Query
        query={QueriesQL.list}
        variables={params}
        datapath={"sites.get.domains.list"}
      >
        {({ values }) => <Listing listing={values} params={params} />}
      </Section.Query>
    </Container>
  );
};

// Written out rather than driven through the shared list widget, because this
// screen is not really a listing — it is the setup instructions, and the row a
// person comes here for is the DNS record they have to publish. The shared
// widget also pages on a cursor this collection does not have.
const Listing = ({ listing, params }) => {
  const items = (listing && listing.items) || [];

  if (items.length === 0) {
    return <p className="text-muted">No domains attached yet.</p>;
  }

  return (
    <Table responsive>
      <thead>
        <tr>
          <th>Domain</th>
          <th>Status</th>
          <th>Ownership record</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {items.map((row) => (
          <DomainRow key={row.host} row={row} params={params} />
        ))}
      </tbody>
    </Table>
  );
};

const DomainRow = ({ row, params }) => {
  const active = row.status === ACTIVE;

  return (
    <tr>
      <td>{row.host}</td>
      <td>
        <Badge color={active ? "success" : "warning"}>{row.status}</Badge>
      </td>
      <td>
        {active ? (
          <span className="text-muted">verified {row.verifiedAt}</span>
        ) : (
          // Both halves, because a TXT record needs a name AND a value and
          // people publish the wrong one otherwise. Selectable text rather
          // than a copy button: this gets pasted into somebody's DNS panel.
          <code className="small">
            {TXT_PREFIX}.{row.host} TXT {row.token}
          </code>
        )}
      </td>
      <td className="text-nowrap">
        <VerifyButton row={row} params={params} />{" "}
        <RemoveButton row={row} params={params} />
      </td>
    </tr>
  );
};

// Safe to press twice and safe to press on a domain that is already active:
// it re-reads DNS every time, which is what makes it both the "check my record"
// button and the way a domain is re-proved later.
const VerifyButton = ({ row, params: { siteId } }) => (
  <Mutation
    mutation={QueriesQL.verify}
    update={QueriesQL.update()}
    onMutate={({ handler }) => {
      handler({ variables: { siteId, host: row.host } });
    }}
    onCompleted={() => {
      Notify.success(`${row.host} verified.`);
    }}
    onError={(error) => {
      Notify.error(error.toString());
    }}
  >
    {({ mutate }) => (
      <Button color="secondary" onClick={() => mutate()}>
        Verify
      </Button>
    )}
  </Mutation>
);

const RemoveButton = ({ row, params: { siteId } }) => (
  <Mutation
    mutation={QueriesQL.remove}
    update={QueriesQL.update()}
    onMutate={({ handler }) => {
      handler({ variables: { siteId, host: row.host } });
    }}
    onCompleted={() => {
      Notify.success(`${row.host} detached.`);
    }}
    onError={(error) => {
      Notify.error(error.toString());
    }}
  >
    {({ mutate }) => (
      <Button color="danger" onClick={() => mutate()}>
        Detach
      </Button>
    )}
  </Mutation>
);
